import Vue from 'vue'
import VueRouter from 'vue-router'
import notFound from '@/views/404.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/login/login.vue')
  },
  {
    path: '*', // 通配符路由，匹配所有不符合以上定义的路由
	meta: {
		title: '合力云',
	    keepAlive: true, 
	},
    component: notFound // 显示404页面
  },
  {
    path: '/demo',
    name: 'demo',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/demo.vue')
  },
  {
    path: '/mainview',
    name: 'mainview',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/mainView/mainView.vue')
  },
  // {
  //   path: '/projectView',
  //   name: 'projectView',
  // 	meta: {
  // 		title: '合力云',
  // 	    keepAlive: true, 
  // 	},
  //   component: () => import('../views/projectView/projectView.vue')
  // },
  {
    path: '/projectMonitor',
    name: 'projectMonitor',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/projectMonitor/projectMonitor.vue')
  },
  {
    path: '/historyAnalysis',
    name: 'historyAnalysis',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/energyAnalysis/analysis.vue')
  },
  {
    path: '/subarea',
    name: 'subarea',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/subarea/subarea.vue')
  },
  {
    path: '/createDevice',
    name: 'createDevice',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/device/edit/createDevice.vue')
  },
  {
    path: '/projecteEvent',
    name: 'projecteEvent',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/event/event.vue')
  },
  {
    path: '/log',
    name: 'log',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/event/logs.vue')
  },
  {
    path: '/message',
    name: 'message',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/projectSource/message/message.vue')
  },
  {
    path: '/setProject',
    name: 'setProject',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/projectSource/setProject/setProject.vue')
  },
  {
    path: '/projectRole',
    name: 'projectRole',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/project/projectRole.vue')
  },
  {
    path: '/projectMember',
    name: 'projectMember',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/project/projectMember.vue')
  },
  {
    path: '/projectPermissions',
    name: 'projectPermissions',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/project/projectPermissions.vue')
  },
  {
    path: '/systemSettings',
    name: 'systemSettings',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/system/systemSettings.vue')
  },
  {
    path: '/systemProject',
    name: 'systemProject',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/system/systemProject.vue')
  },
  {
    path: '/systemRole',
    name: 'systemRole',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/system/systemRole.vue')
  },
  {
    path: '/systemUser',
    name: 'systemUser',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/system/systemUser.vue')
  },
  {
    path: '/systemPermissions',
    name: 'systemPermissions',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/system/systemPermissions.vue')
  },
  {
    path: '/deviceType',
    name: 'deviceType',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/device/type/deviceType.vue')
  },
  {
    path: '/deviceFactory',
    name: 'deviceFactory',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/device/factory/deviceFactory.vue')
  },
  {
    path: '/deviceModel',
    name: 'deviceModel',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/device/model/deviceModel.vue')
  },
  {
    path: '/mapView',
    name: 'mapView',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/mapView/mapView.vue')
  },
  {
    path: '/emsWeb',
    name: 'emsWeb',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/emsWeb/emsWeb.vue')
  },
  {
    path: '/emsPolicy',
    name: 'emsPolicy',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/emsPolicy/emsPolicy.vue')
  },
  {
    path: '/stationRunStatus',
    name: 'stationRunStatus',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/stationRunStatus/stationRunStatus.vue')
  },
  {
    path: '/editEmsSystem',
    name: 'editEmsSystem',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/editEmsSystem/editEmsSystem.vue')
  },
  {
    path: '/editStationKeyRuntime',
    name: 'editStationKeyRuntime',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/editStationKeyRuntime/editStationKeyRuntime.vue')
  },
  {
    path: '/editStationEvent',
    name: 'editStationEvent',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/editStationEvent/editStationEvent.vue')
  },
  {
    path: '/editEmsPirv',
    name: 'editEmsPirv',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/editEmsPirv/editEmsPirv.vue')
  },
  {
    path: '/hemCusomer',
    name: 'hemCusomer',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/hem/hemCusomer.vue')
  },
  {
    path: '/hemCusomerType',
    name: 'hemCusomerType',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/hem/hemCusomerType.vue')
  },
  {
    path: '/hemHistoryStation',
    name: 'hemHistoryStation',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/hem/hemHistoryStation.vue')
  },
  {
    path: '/hemSuiteModel',
    name: 'hemSuiteModel',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/hem/hemSuiteModel.vue')
  },
  {
    path: '/hemSuite',
    name: 'hemSuite',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/hem/hemSuite.vue')
  },
  {
    path: '/customerList',
    name: 'customerList',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/vpp/customerList/customerList.vue')
  },
  {
    path: '/customerType',
    name: 'customerType',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/vpp/customerType/customerType.vue')
  },
  {
    path: '/demandList',
    name: 'demandList',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/vpp/demandList/demandList.vue')
  },
  {
    path: '/supplyList',
    name: 'supplyList',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/vpp/supplyList/supplyList.vue')
  },
  {
    path: '/tradelog',
    name: 'tradelog',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/vpp/tradelog/tradelog.vue')
  },
  {
    path: '/chatList',
    name: 'chatList',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/vpp/customerServe/chatList.vue')
  },
  {
    path: '/chatListMan',
    name: 'chatListMan',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/vpp/customerServe/chatListMan.vue')
  },
  {
    path: '/arclist',
    name: 'arclist',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/vppService/arclist/arclist.vue')
  },
  {
    path: '/rsplist',
    name: 'rsplist',
  	meta: {
  		title: '合力云',
  	    keepAlive: true, 
  	},
    component: () => import('../views/vppService/rsplist/rsplist.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title // 在路由切换前将页面标题设置为meta的title值
  next()
})
export default router
